import { Text } from '#app/components/Primitives/Text.js';
import { type ButtonVariant } from './types.js';
import { css, styled } from 'styled-components';

export const StyledButtonText = styled(Text).attrs({
  as: 'span',
})<{
  $isDisabled: boolean;
  $isFocused: boolean;
  $isHovered: boolean;
  $isLoading: boolean;
  variant: ButtonVariant;
}>`
  ${({ $isDisabled, $isFocused, $isHovered, $isLoading, variant }) => {
    if (variant === 'V2Link') {
      const shouldUnderline =
        ($isHovered || $isFocused) && !$isDisabled && !$isLoading;
      return css`
        ${shouldUnderline &&
        css`
          text-decoration-line: underline;
          text-underline-offset: 6px;
        `}
      `;
    }

    return null;
  }}
`;
